"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _DownloadLinkBox = _interopRequireDefault(require("../../DownloadLinkBox/DownloadLinkBox"));
var _TagsGroup = _interopRequireDefault(require("../../../TagsGroup/TagsGroup"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.left-container .formation .downloadlinkbox-container,\n.left-container .events .downloadlinkbox-container,\n.left-container .industry .downloadlinkbox-container {\n  padding-bottom: 0px; }\n\n.left-container .formation .title,\n.left-container .events .title,\n.left-container .industry .title {\n  font-size: 20px; }\n\n.left-container .formation {\n  max-width: 100%;\n  height: min-content;\n  background-color: rgba(228, 27, 19, 0.1); }\n\n.left-container .events {\n  max-width: 100%;\n  height: min-content;\n  background-color: rgba(140, 173, 219, 0.1); }\n\n.left-container .industry {\n  max-width: 100%;\n  height: min-content;\n  background-color: rgba(47, 183, 137, 0.1); }\n";
  const fileName = "Formation_Formation";
  const element = document.querySelector("style[data-sass-component='Formation_Formation']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Element = _ref => {
  let {
    item,
    lang
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-padding-03-top sia-padding-03-right sia-padding-02-left sia-border-01-top"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-padding-03-bottom"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "title sia-text-10 "
  }, item.title), item.links?.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-margin-02-top"
  }, item.links.map((link, index) => {
    const quaternaryTags = [{
      label: link.type || '',
      type: 'quaternary'
    }];
    const tertiaryTags = link.location?.map(el => {
      return {
        label: el.label || '',
        type: 'tertiary'
      };
    }) || [];
    const tags = [...quaternaryTags, ...tertiaryTags];
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: "sia-padding-03-bottom"
    }, /*#__PURE__*/_react.default.createElement(_DownloadLinkBox.default, {
      items: [{
        link: {
          title: link.title,
          url: link.url,
          original_url: link.url
        }
      }],
      lang: lang
    }), tags.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginLeft: '34px'
      }
    }, /*#__PURE__*/_react.default.createElement(_TagsGroup.default, {
      items: tags
    })));
  })))));
};
const linksMock = [{
  title: 'Kursbezeichnung, Datum, Ort',
  url: 'https://www.sia.ch',
  type: 'Webminar',
  location: [{
    label: 'ZH'
  }, {
    label: 'GE'
  }]
}, {
  title: 'Kursbezeichnung Lorem ipsum, Datum, Ort',
  url: 'https://www.sia.ch',
  type: 'Hybrid',
  location: [{
    label: 'ZH'
  }]
}];
const Formation = _ref2 => {
  let {
    item,
    lang
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-border-01-bottom"
  }, item.formation && /*#__PURE__*/_react.default.createElement("div", {
    className: "formation"
  }, /*#__PURE__*/_react.default.createElement(Element, {
    item: item.formation,
    lang: lang
  })), item.events && /*#__PURE__*/_react.default.createElement("div", {
    className: "events"
  }, /*#__PURE__*/_react.default.createElement(Element, {
    item: item.events,
    lang: lang
  })), item.industry && /*#__PURE__*/_react.default.createElement("div", {
    className: "industry"
  }, /*#__PURE__*/_react.default.createElement(Element, {
    item: item.industry,
    lang: lang
  })));
};
var _default = exports.default = Formation;